import { h, VNode } from 'preact';
import { UserInput } from '../types';
import { Dispatch, StateUpdater } from 'preact/hooks';

interface UserDetailsFormProps {
  userInput: UserInput;
  showEmailError: boolean;
  showAgeError: boolean;
  onUpdateUserInput: Dispatch<StateUpdater<UserInput>>;
}

export function UserDetailsForm({
  userInput,
  showEmailError,
  showAgeError,
  onUpdateUserInput,
}: UserDetailsFormProps): VNode {
  return (
    <div>
      <div>
        <div className="label">Email address</div>
        <input
          type="text"
          className="coloredInputDark"
          style={{ width: '100%' }}
          value={userInput.email}
          onChange={e =>
            onUpdateUserInput(prev => ({
              ...prev,
              email: (e.target as HTMLInputElement).value.trim(),
            }))
          }
        />

        {showEmailError && (
          <div className="info" id="errorText">
            Please enter a valid email address
          </div>
        )}
      </div>

      <div>
        <div className="label">Enter age</div>
        <input
          type="number"
          id="ageInput"
          value={userInput.age || ''}
          onChange={e =>
            onUpdateUserInput(prev => ({
              ...prev,
              age: +(e.target as HTMLInputElement).value,
            }))
          }
        />

        {showAgeError && (
          <div className="info" id="errorText">
            Please enter a valid age
          </div>
        )}
      </div>
    </div>
  );
} 